import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './EdgeComputing.css';

const EdgeComputing = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="edge-computing-page-wrapper">
      <div className="edge-computing-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Edge Computing')}
        />

        <div className="edge-computing-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="edge-computing-page-hero">
          <h1>Edge Computing Services</h1>
          <p>
            BlackRoth delivers high-performance Edge Computing solutions that
            enable real-time data processing closer to the source, reducing
            latency, improving reliability, and enhancing system efficiency.
          </p>
        </div>

        <section className="edge-computing-page-section">
          <h2>Overview</h2>
          <p>
            Edge Computing brings computation and intelligence closer to devices
            and data sources. BlackRoth helps organizations design and deploy
            edge-based architectures that support low-latency applications,
            real-time analytics, and distributed intelligence.
          </p>
        </section>

        <section className="edge-computing-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our Edge Computing solutions are built to operate reliably in
            distributed environments, ensuring performance, scalability, and
            seamless integration with cloud and on-premise systems.
          </p>
        </section>

        <section className="edge-computing-page-section">
          <h2>Services We Offer</h2>
          <ul className="edge-computing-service-list">
            <li>Edge Architecture Design & Consulting</li>
            <li>Real-Time Data Processing</li>
            <li>IoT & Sensor Data Integration</li>
            <li>AI at the Edge</li>
            <li>Edge Security & Device Management</li>
            <li>Hybrid Edge-Cloud Solutions</li>
            <li>Edge Application Development</li>
            <li>Deployment, Monitoring & Optimization</li>
          </ul>
        </section>

        <section className="edge-computing-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            Edge Computing solutions from BlackRoth are used across industries
            such as manufacturing, smart cities, healthcare, energy, retail,
            and transportation to enable real-time insights and autonomous
            operations.
          </p>
        </section>

        <section className="edge-computing-page-section">
          <h2>Technology Stack</h2>
          <p>
            We utilize modern edge technologies including containerization,
            Kubernetes at the edge, Linux-based systems, IoT platforms,
            AI inference engines, and secure communication protocols.
          </p>
        </section>

        <section className="edge-computing-page-section">
          <h2>Security & Reliability</h2>
          <p>
            BlackRoth follows enterprise-grade security standards to protect
            edge devices, data, and communications, ensuring secure and
            resilient edge computing environments.
          </p>
        </section>
      </div>
    </div>
  );
};

export default EdgeComputing;

